/**
 * Single source of truth for the app's locales.
 *
 * Cookie-based i18n (no URL prefix). To add a language later (e.g. Chinese
 * or Japanese): append its code here, add `messages/<code>.json`, and — if
 * it's right-to-left — add it to `rtlLocales`. Nothing else needs to change.
 */
export const locales = ["en", "ar", "zh"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

/** Locales that render right-to-left. */
export const rtlLocales: readonly Locale[] = ["ar"];

/** next-intl's default cookie name — reused so no extra config is needed. */
export const LOCALE_COOKIE = "NEXT_LOCALE";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (locales as readonly string[]).includes(value);
}

export function dirFor(locale: Locale): "rtl" | "ltr" {
  return rtlLocales.includes(locale) ? "rtl" : "ltr";
}
